import { motion } from "framer-motion";
import { CheckCircle2, ShieldCheck, ArrowRight } from "lucide-react";

import Seo from "../../Components/SEO/Seo";
import Container from "../../Components/Container/Container";
import Button from "../../Components/Button/Button";
import { ACCURACY_COMPARISON_ROWS } from "../../Data/dataAccuracyData";

import "../../Style/resources/data-accuracy.css";

export default function DataAccuracy() {
  const handleConsultation = () => {
    window.history.pushState({}, "", "/contact");
    window.dispatchEvent(new Event("popstate"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="accuracy-page">
      <Seo
        title="Data Accuracy & Comparison Benchmark | Conectify Tech"
        description="Let the Accurate and Hygiene Data be the Main Source for your Marketing Leads. Compare Conectify Tech data quality, ownership, and coverage against ZoomInfo."
      />

      {/* Top Breadcrumb / Hero Header Banner */}
      <section className="accuracy-banner">
        <Container>
          <div className="accuracy-banner__content">
            <span className="accuracy-banner__tag">
              <ShieldCheck size={14} /> Hygiene & Accuracy Benchmark
            </span>
            <h1 className="accuracy-banner__title">Data Accuracy</h1>
          </div>
        </Container>
      </section>

      {/* Main Split Section */}
      <section className="accuracy-body">
        <Container>
          <div className="accuracy-grid">
            {/* Left Column: Context & Editorial */}
            <motion.div
              className="accuracy-content"
              initial={{ opacity: 0, x: -24 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.55 }}
            >
              <h2 className="accuracy-title">
                Let the Accurate and Hygiene Data be the{" "}
                <span className="text-gradient">Main Source for your Marketing Leads</span>
              </h2>

              <p className="accuracy-lead">
                Our Data Quality and Server capabilities are second to none and allow each ongoing
                executed campaign to sustain consistent results which is not the standard in this
                industry. If we notice that a campaign is not performing well, we first will address
                the client and review the creative for any messaging loopholes which may cause a
                lack of effectiveness. We will then send additional mail to help boost results to
                the levels as expected.
              </p>

              <div className="accuracy-actions">
                <Button icon={<ArrowRight size={18} />} onClick={handleConsultation}>
                  Request Accuracy Audit
                </Button>
              </div>
            </motion.div>

            {/* Right Column: Comparison Table Card */}
            <motion.div
              className="accuracy-table-wrap"
              initial={{ opacity: 0, x: 24 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.55, delay: 0.1 }}
            >
              <div className="accuracy-matrix">
                {/* Headers */}
                <div className="matrix-row matrix-row--head">
                  <div className="matrix-cell matrix-cell--feature"></div>
                  <div className="matrix-cell matrix-cell--brand">
                    <div className="brand-head-badge brand-head-badge--Conectify">
                      Conectify Tech
                    </div>
                  </div>
                  <div className="matrix-vs-indicator" aria-hidden="true">
                    <span>VS</span>
                  </div>
                  <div className="matrix-cell matrix-cell--competitor">
                    <div className="brand-head-badge brand-head-badge--zoominfo">
                      ZoomInfo
                    </div>
                  </div>
                </div>

                {/* Rows */}
                {ACCURACY_COMPARISON_ROWS.map((row, idx) => (
                  <div
                    key={row.feature}
                    className={`matrix-row ${idx % 2 === 0 ? "is-even" : ""}`}
                  >
                    <div className="matrix-cell matrix-cell--feature">
                      <span>{row.feature}</span>
                    </div>

                    <div className="matrix-cell matrix-cell--brand">
                      <div className="cell-content">
                        <CheckCircle2 size={14} className="cell-icon-check" />
                        <span>{row.Conectify}</span>
                      </div>
                    </div>

                    <div className="matrix-cell-divider" aria-hidden="true" />

                    <div className="matrix-cell matrix-cell--competitor">
                      <span className="competitor-text">{row.zoominfo}</span>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </Container>
      </section>
    </div>
  );
}